import type { JSX } from 'react'

interface MandatoryProps {
    mandatory?: boolean
}

export default function Mandatory({ mandatory = false }: MandatoryProps): JSX.Element {
    if (mandatory) {
        return <span className="ml-0.5 align-baseline text-[1em] leading-none font-medium text-red-400">*</span>
    }
    return <></>
}
